var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="{{opzioni.rebind}}\n<kendo-calendar style=\"width: 100%\" ng-model=\"model[options.key]\" k-options=\"opzioni\" k-rebind=\"opzioni.rebind\"></kendo-calendar>\n";
var id1="bsscalendario.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;